import React, { Component } from 'react';
import CategoryCard from './CategoryCard';
import './CategoryList.css'

class CategoryList extends Component {
    render () {
        const style={
            container: {
                left: 0,
                // border: '1px rgba(0,0,0,0.2) solid',
                padding: '0 10px',
                margin: 0,
                // display: '-webkit-box',
                // display: '-ms-flexbox',
                display: 'flex',
                WebkitBoxOrient: 'horizontal',
                WebkitBoxDirection: 'normal',
                MsFlexDirection: 'row',
                flexDirection: 'row',
                // WebkitBoxAlign: 'center',
                // MsFlexAlign: 'center',
                // alignItems: 'center',
                boxSizing: 'border-box',
                // width: '100%',
                overflow: 'hidden',
                overflowX: 'scroll',
                overflowY: 'hidden',
                WebkitScrollbar: 'none',
                // flex: '0 0 auto'

            },
            tile: {
                margin: 15
            },
            project: {
                // display: 'inline-block'
            },
            list: {
                marginTop: 15
            },
            separator: {
                background: '#CFE89C',
                height: 5,
                borderRadius: 2
            }
        }

        const { title, categories } = this.props;
        return (
            <div style={style.list} className="tikki-list-main">
                <h3>{title}</h3>
                <div style={style.separator} />
                <div style={style.container} className="tikki-list-container">
                        {categories.map((item, index) => (
                            <div style={style.tile} key={index}>
                                <CategoryCard item={item} key={item.categoryId} style={style.project} />
                            </div>
                        ))}
                </div>
            </div>
        );
    };
};

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/Categories/CategoryList.js